import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ProjectTypesDataGrid } from "src/components/views/erp/project/projectTypes/ProjectTypesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/project/projectTypes")({
	staticData: { title: i18n.t("project_types"), legacyViewKey: "projectTypesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ProjectTypesDataGrid />;
}
